<template>
    <app-layout title="Data Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion
                                    :multiple="true"
                                    :activeIndex="[1, 2, 3]"
                                >
                                    <AccordionTab
                                        :disabled="action == 'create'"
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Status</span
                                                >
                                            </span>
                                        </template>
                                        <StatusDokumenPengadaanInfo></StatusDokumenPengadaanInfo>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Data Utama</span
                                                >
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full my-2"
                                                    for="total_hps"
                                                    value="Total HPS"
                                                />
                                                <InputNumber
                                                    v-model="form.total_hps"
                                                    inputId="total_hps"
                                                    locale="id-ID"
                                                    :minFractionDigits="2"
                                                />
                                            </div>

                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full my-2"
                                                    for="id_penyedia"
                                                    value="Penyedia : "
                                                />
                                                <Chip
                                                    :label="
                                                        dataViewDokumenPengadaan
                                                            .penyedia
                                                            .nama_perusahaan
                                                    "
                                                />
                                            </div>
                                            <div class="field w-full px-3 mb-3">
                                                <JetLabel
                                                    class="w-full my-2"
                                                    for="id_penyedia"
                                                    value="Ubah Penyedia"
                                                />
                                                <Dropdown
                                                    v-model="form.id_penyedia"
                                                    :options="penyediaOptions"
                                                    optionLabel="nama_perusahaan"
                                                    optionValue="id"
                                                    filter
                                                    filterBy="nama_perusahaan"
                                                    @filter="fetchPenyedia"
                                                    placeholder="Select Penyedia"
                                                />
                                            </div>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Existing File :
                                                </span>
                                            </span>
                                        </template>
                                        <FileDisplay
                                            :existing_files="
                                                dataViewDokumenPengadaan.file
                                            "
                                        />
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Ubah File
                                                </span>
                                            </span>
                                        </template>
                                        <FileInput
                                            :file_uploads="file_uploads"
                                        />
                                    </AccordionTab>
                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Jadwal
                                                </span>
                                            </span>
                                        </template>
                                        <JadwalInput :jadwals="jadwals" />
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <button
                                    @click="submitForm"
                                    class="px-4 py-2 bg-blue-500 text-white rounded"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetSectionBorder from "@/Jetstream/SectionBorder.vue";
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import JadwalInput from "./../partials/JadwalInput.vue";
import FileInput from "./../partials/FileInput.vue";
import FileDisplay from "./../partials/FileDisplay.vue";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import Divider from "primevue/divider";
import Chip from "primevue/chip";

import axios from "axios";
import { Inertia } from "@inertiajs/inertia";

export default defineComponent({
    components: {
        AppLayout,
        JetSectionBorder,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        Input,
        StatusDokumenPengadaanInfo,
        JadwalInput,
        FileInput,
        InputNumber,
        Dropdown,
        Divider,
        Chip,
        FileDisplay,
    },
    props: {
        action: String,
        dataViewDokumenPengadaan: Object,
        files: [Object, Array],
    },
    mounted() {
        console.log(
            "DATA dataViewDokumenPengadaan: ",
            this.dataViewDokumenPengadaan
        );
        this.initializeFile();
        this.initializeJadwal();
        this.fetchPenyedia({ query: "" });
        // this.penyediaOptions = [this.dataViewDokumenPengadaan.penyedia];
        this.form = {
            total_hps: this.dataViewDokumenPengadaan.total_hps,
            id_penyedia: this.dataViewDokumenPengadaan.id,
        };
    },
    data() {
        return {
            file_uploads: [],
            jadwals: [],
            penyediaOptions: [],
            form: {
                total_hps: null,
                id_penyedia: null,
            },
        };
    },
    methods: {
        initializeFile() {
            this.dataViewDokumenPengadaan.file.forEach((file) => {
                this.file_uploads.push({
                    id_file_dokumen_pengadaan: file.id,
                    id_jadwal_pengadaan: file.id_jadwal_pengadaan,
                    id_dokumen_pengadaan: file.id_dokumen_pengadaan,
                    id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
                    kode_file: file.kode_file,
                    kode_prosedur: file.kode_prosedur,
                    nama_file: file.nama_file,
                    file_path: file.file_path,
                    file_type: file.file_type,
                    file_dokumen_type: file.file_dokumen_type,
                    file_dokumen_type_id: file.file_dokumen_type_id,
                    multiple: file.is_multiple === 1,
                    new_file: [],
                });
            });
        },
        initializeJadwal() {
            this.dataViewDokumenPengadaan.jadwal.forEach((jadwal) => {
                this.jadwals.push({
                    ...jadwal,
                    ...(this.action == "create"
                        ? {
                              existing_jadwal: {
                                  waktu_mulai: null,
                                  waktu_selesai: null,
                                  tempat: null,
                                  keterangan: null,
                              },
                          }
                        : {}),
                });
            });
        },
        async fetchPenyedia(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_penyedia",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    }
                );
                this.penyediaOptions = response.data;
            } catch (error) {
                console.error("Error fetching penyedia:", error);
            }
        },
        submitForm() {
            Inertia.post(
                "/dokumen_pengadaan/action_create_penyusunan_dokumen_pengadaan",
                {
                    form: this.form,
                    file_uploads: this.file_uploads,
                    jadwals: this.jadwals,
                }
            );
        },
    },
});
</script>
